import React, { Component } from 'react';
import { connect } from 'react-redux';

// Bootstrap component
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';

//Component
import ImageItemGroupResponse from '../ImageItem/ImageItemResponse/ImageItemResponse'
import { processItemResponse } from '../../../../utilities/processResponse';
// Actions
import { getAnsweredQuestionCount, getQuestionList } from '../../../../actions/SurveyAction';

//Assets
import './ImageItem.css';
import ImageItemResponse from '../ImageItem/ImageItemResponse/ImageItemResponse';

class ImageItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            undoIcon:false,
            naCheck:false
        }

        this.restoreSingleItemArr = [];
    }

    componentDidUpdate(prevProps) {
        var questionId = this.props.scrollToQuestionId;

        if (questionId !== null) {
            if (this.props.scrollToQuestionId !== prevProps.scrollToQuestionId) {
                this.scrollToQuestion(questionId);
            }
        }

    }

    /**
     * Method to scroll respective element based on id
     *
     * @param { questionId:string }
     *
     */
    scrollToQuestion = (questionId) => {
        var scrollDiv = document.getElementById("ScrollDiv_" + questionId);
            scrollDiv.style.paddingTop = "40px";
            scrollDiv.scrollIntoView({top:scrollDiv.offsetTop, behavior:"smooth"});
    }

    /**
     * Reset the question options
     *
     */
    resetAll = (event, configuration, rateeKey, naType) => {
        const { questionItemList, dispatch, answeredQuestionCount } = this.props;
        const { key } = configuration;
        const itemTagKey = key;
        var itemList = questionItemList[key];
        var nodeList = document.getElementsByClassName(`OpenEnd_${key}`);
        /** Question object  */
        itemList.filter((items, i) => {
            if (items.itemResponses.length > 0) {
                this.restoreSingleItemArr = items.itemResponses;
                this.setState({undoIcon:true});
            }

            var tempArr = this.restoreSingleItemArr.filter((el) => el !== null);

            if (items.key === itemTagKey) {

                if (naType) {
                    for (const key in nodeList) {
                        if (nodeList.hasOwnProperty(key)) {
                            const element = nodeList[key];
                            element.disabled = true;
                            element.value = "";
                        }
                    }
                }
                if (naType === "clear" || typeof naType === "boolean") {
                    items.itemResponses = [];
                    items.isAnswer = false;
                    items.isRequired = false ;

                    if (naType !== "clear") {
                        this.handleNaDisabled(naType, itemTagKey);
                        items.isNA = naType === false ? false : true;
                    }

                    for (const key in nodeList) {
                        if (nodeList.hasOwnProperty(key)) {
                            const element = nodeList[key];

                            if (naType !== "clear") {
                                element.disabled = naType ? true : false;
                            } else {
                                element.disabled = false;
                            }
                            element.value = "";
                        }
                    }
                    dispatch(getQuestionList(questionItemList));
                } else {
                    for (const key in nodeList) {
                        if (nodeList.hasOwnProperty(key)) {
                            const element = nodeList[key];
                            element.disabled = false;
                        }
                    }

                    /** Assign the value of input box */
                    tempArr.map((res, i) => {
                        document.getElementById(`OpenEndedInput_${i+1}`).value = res.userResponseDescription;
                    });

                    // items.userResponse = tempArr;
                    items.itemResponses = tempArr;
                    items.isAnswer = true;
                    items.isNA = false;
                    this.setState({undoIcon:false});
                }
            }
            return true;
        });
        let remainCount = answeredQuestionCount - 1;
        dispatch(getAnsweredQuestionCount(remainCount));
    }

    handleNaDisabled = (naType, itemTagKey) => {
        var scrollDiv = document.getElementById(`ScrollDiv_${itemTagKey}`);
        scrollDiv.style.fontStyle = naType === false ? 'normal' :'italic';
        scrollDiv.style.color = naType === false ? '#0f5ea0' :'#8787';
    }
    /**
     * Method to load spinner image
     *
     */
    renderSpinner = (configuration) => {
        return <i className={`fa fa-spinner fa-spin fa_${configuration.key}`} style={{"fontSize":"25px", "display":"none"}}></i>
    }

    renderTextArea(responseConfiguration) {
        const { configuration, questionItemList } = this.props;
        let key = this.currentRatee.key;

        return (
            <td>
                <ImageItemResponse
                    className={configuration.className}
                    configuration={responseConfiguration}
                    suppressLabel={true}
                    items={configuration}
                    questionItemList={questionItemList}
                    rateeKey={key}
                    openOreModal = {this.props.openOreModal}
                />
            </td>
        );
    }

    renderRatee(ratee, me) {
        const { configuration } = this.props;
        this.currentRatee = ratee;
        this.currentButtonGroup = [this.currentRatee.key, configuration.key].join(":");
        return this.renderTextArea(configuration, this);
    }

    /**
     * N/A check box functionality
     *
     */
    naOpenEndCheck = (event, configuration) => {
        try {
            //const { itemResponses } = this.props;

            var itemKey = configuration.key;
            var naCheck = event.target.checked;
            var surveyItem = document.getElementById(`survey-item-block_${itemKey}`);
            this.setState({naCheck:naCheck});

            if (naCheck) {
                surveyItem.style.background = "#F2F2F2";
                surveyItem.style.color = "#ACACAC";
                var responseSet = this.props.itemResponses[itemKey] = {};
                var itemResponses = [{
                    "itemType"     : configuration.itemType,
                    "buttonGroup"  : null,
                    "sequence"     : 1,
                    "isNa"         : naCheck,
                    "response"     : null,
                    "responseValue": null,
                    "openEnd"      : null,
                    "serverStatus" : 0,
                    "hasPosted"    : 0
                }];
                processItemResponse(itemKey, responseSet, itemResponses,"onChange");
                this.props.handleItemResponse(configuration.key, this.props.itemResponses, "itemChange");
            } else {
                surveyItem.style.background = "#fff";
                surveyItem.style.color = "#000";
            }

            this.resetAll(null, configuration, null, naCheck);
        } catch (error) {
            console.log("Exception: while check n/a checkbox in single select:_", error);
        }
    }

    /**
     * Restore value before selected
     *
     */
    resetOpenEndResponse = (event, configuration) => {
        this.resetAll(null, configuration, null, "reset");
    }

    renderView = (configuration, reviewPageKey) => {
        const { questionItemList, pageInstrumentConfiguration, itemResponses, itemTempResponses, getAllResponses, itemCount, isLastPage, activePageKey, pageNumber, currentActivePageCount, dataCollectionGuid, assessmentInfosForDataCollection } = this.props;
        const { scales } = pageInstrumentConfiguration;
        const scaleResponses = scales[configuration.scaleKey];
        const assessmentObj = assessmentInfosForDataCollection.assessmentInfosForDataCollection || [];

        return <ImageItemGroupResponse
                key={configuration.key}
                configuration={scaleResponses}
                currentActivePageCount={currentActivePageCount}
                pageNumber={pageNumber}
                items={configuration}
                itemResponses={itemResponses}
                itemTempResponses={itemTempResponses}
                scaleResponses={scaleResponses}
                questionItemList={questionItemList}
                pageInstrumentConfiguration={pageInstrumentConfiguration}
                itemCount={itemCount}
                isLastPage={isLastPage}
                activePageKey={activePageKey}
                rateeKey={dataCollectionGuid}
                ratees={assessmentObj}
                putAllForItemCollection={this.props.putAllForItemCollection}
                handleItemResponse={(itemKey, itemResponsesSet, type, dataGuid) => this.props.handleItemResponse(itemKey, itemResponsesSet, type, dataGuid)}
                openOreModal = {this.props.openOreModal}
            />
    }

    render() {
        const { configuration, ratees, questionItemList, pageInstrumentConfiguration } = this.props;
        const { scales, itemNaUncheckedButtonKey, itemResetButtonKey, itemRestoreButtonKey, buttons, sections } = pageInstrumentConfiguration;

        // const { itemNaUncheckedButtonKey, itemResetButtonKey, itemRestoreButtonKey, buttons, scales } = pageInstrumentConfiguration !== undefined ? pageInstrumentConfiguration:null;
        const scaleResponses = scales[configuration.scaleKey];
        var jsx = '';
        var rateeKey = null;
        var tempQuestionList = [];
        var naResponse = scales[configuration.scaleKey].naResponse;

        for (const key in questionItemList) {
            if (questionItemList.hasOwnProperty(key)) {
                const element = questionItemList[key];
                tempQuestionList.push(element)
            }
        }

        for (const key in ratees) {
            if (ratees.hasOwnProperty(key)) {
                const element = ratees[key];
                rateeKey = element.key;
            }
        }

        const responseLength = tempQuestionList.filter((item, i) => {
            if (item.key === configuration.key ) {
                return item.userResponse.length || 0;
            }
        });

        var groupIconsClass = configuration.hasItemResetButton || configuration.hasItemRestoreButton || naResponse !== null ? "ItemGroupIcon" : null;
        if (ratees.length < 2) {
            jsx = (
                <div id={`survey-item-block_${configuration.key}`} className={`_ImageItemType`}>
                    <Row id={`ScrollDiv_${configuration.key}`} className={configuration.itemText && configuration.itemText !== null  ? `_ItemTextCss ${configuration.cssClass !== null ? configuration.cssClass:""}` : null}>
                    {
                        configuration.itemText && configuration.itemText !== null ?
                        <>
                            <Col md={1} className={"ItemSpinner"}>{ this.renderSpinner(configuration) }</Col>
                            <Col xs={10} className="itemText">
                                {/* {configuration.isRequired === true ? <span>*</span> :''}
                                <span className="itemTag" dangerouslySetInnerHTML={{__html:configuration.itemTag}}></span>
                                <span dangerouslySetInnerHTML={{__html: configuration.itemText}}></span> */}
                            </Col>
                            <Col xs={1} className={groupIconsClass}>
                                {naResponse !== null && naResponse !== undefined ? <span
                                    key={buttons[itemNaUncheckedButtonKey].key}
                                    className={`_ItemNaUncheckedButton ${buttons[itemNaUncheckedButtonKey].buttonCssClass}`}
                                >
                                    <Form.Check type="checkbox" onChange={(event) => this.naOpenEndCheck(event, configuration)}/> <span>{buttons[itemNaUncheckedButtonKey].buttonText}</span>
                                </span>:null}
                                {configuration.hasItemResetButton ?
                                    <span
                                        key={buttons[itemResetButtonKey].key}
                                        className={`_ItemResetButton ${buttons[itemResetButtonKey].buttonCssClass}`}
                                        onClick={(event) => this.resetAll(event, configuration, rateeKey, "clear")}
                                    >
                                        { responseLength.length > 0 && this.state.undoIcon === false ?  <i className={buttons[itemResetButtonKey].buttonFontAwesome}></i> : null }
                                    </span>
                                :null}
                                { configuration.hasItemRestoreButton ?
                                    <span
                                        key={buttons[itemRestoreButtonKey].key}
                                        className={`_ItemRestoreButton ${buttons[itemRestoreButtonKey].buttonCssClass}`}
                                        onClick={(event) => this.resetOpenEndResponse(event, configuration)}
                                    >
                                        { this.state.undoIcon === true && this.state.naCheck === false ?  <i className={buttons[itemRestoreButtonKey].buttonFontAwesome}></i> : null }
                                    </span>
                                    :null
                                }
                            </Col>
                        </>:null
                    }
                    </Row>
                    {/* <Row className="_RankedRow">
                        <Col xs={1}></Col>
                        <Col xs={11}>
                            { configuration.isPlaceholder === false ? <span>This is the placeholder</span>: null }
                        </Col>
                    </Row> */}
                    <Row>
                        { 
                            configuration.itemText === null ? 
                            <>
                                <Col md={1} className={"ItemSpinner"}> { configuration.itemText === null ? this.renderSpinner(configuration) : "" }</Col>
                        <Col md={11}>

                            {this.renderView(configuration)}
                        </Col>
                            </> 
                            : 
                            <>
                                <Col md={1}></Col>
                                <Col md={10}>
                                    {this.renderView(configuration)}
                                </Col>
                                <Col md={1}></Col>
                            </>
                        }
                        {/* <Col xs={2}></Col> */}
                    </Row>
                </div>
            )
        } else {
            jsx = (
                <div className='SingleSelectItem SingleOrMultiSelectItem'>
                    <div className='PreItemTextDiv'>
                        {/* { this.renderSpinner(configuration) } */}
                    </div>
                    <div id={`ScrollDiv_${configuration.itemTag}`} className='ItemTagItemText'>
                    <div className='ItemTag' dangerouslySetInnerHTML={{__html:configuration.itemTag}}></div>
                        <div className='ItemTagTextHorizontalSpacer'>
                            {configuration.isRequired === true ? <span className="Error_isRequired">*</span> :''}
                        </div>
                        <div className='ItemText' dangerouslySetInnerHTML={{__html: configuration.itemText}}></div>
                        <div className='clearButton'>
                            <button onClick={(event) => this.resetAll(event, configuration, rateeKey)}>Clear</button>
                        </div>
                    </div>
                    { configuration.isPlaceholder === true ? <div className='PostItemTextDiv'>This is placeholder</div>: null }
                    <div className='SingleOrMultiSelectGroup'>
                    <table id='table'>
                        <tbody>
                            {ratees != null ? ratees.map(ratee => {
                                    return (
                                        <tr key={ratee.dataCollectionGuid}>
                                            <td className='RateeName' title={ratee.relationshipDescription}>
                                                {ratee.participantName}
                                            </td>
                                            {this.renderRatee(ratee, this)}
                                        </tr>
                                    );
                                }, this) : null
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            )
        }
        return jsx;
    }
}

const mapStateToProps = state => ({
    scrollToQuestionId:state.survey.scrollToQuestionId,
    answeredQuestionCount:state.survey.answeredQuestionCount,
    assessmentInfosForDataCollection:state.survey.assessmentInfoDataCollectionData
});

export default connect(mapStateToProps)(ImageItem);
